module.exports = function (e) {
  var t = {};

  function a(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, a), n.l = !0, n.exports;
  }

  return a.m = e, a.c = t, a.d = function (e, t, r) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, t) {
    if (1 & t && (e = a(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (a.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      a.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "", a(a.s = 4);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, a) {
  e.exports = a(2)();
}, function (e, t, a) {
  "use strict";

  var r = a(3);

  function n() {}

  e.exports = function () {
    function e(e, t, a, n, i, c) {
      if (c !== r) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var a = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return a.checkPropTypes = n, a.PropTypes = a, a;
  };
}, function (e, t, a) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, a) {
  "use strict";

  a.r(t);
  var r = a(0),
      n = a.n(r),
      i = a(1),
      c = a.n(i);

  function l() {
    return (l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function o(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  var s = function s(e) {
    var t = e.className,
        a = o(e, ["className"]);
    return n.a.createElement("svg", l({
      width: 55,
      height: 80,
      fill: "#FFF",
      viewBox: "0 0 55 80",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      transform: "matrix(1 0 0 -1 0 80)"
    }, n.a.createElement("rect", {
      width: 10,
      height: 20,
      rx: 3
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "4.3s",
      values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 15,
      width: 10,
      height: 80,
      rx: 3
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "2s",
      values: "80;55;33;5;75;23;73;33;12;14;60;80",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 30,
      width: 10,
      height: 50,
      rx: 3
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1.4s",
      values: "50;34;78;23;56;23;34;76;80;54;21;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 45,
      width: 10,
      height: 30,
      rx: 3
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "2s",
      values: "30;45;13;80;56;72;45;76;34;23;67;30",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))));
  };

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function f(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  s.propTypes = {
    className: c.a.string
  }, s.defaultProps = {
    className: void 0
  };

  var m = function m(e) {
    var t = e.className,
        a = f(e, ["className"]);
    return n.a.createElement("svg", u({
      width: 57,
      height: 57,
      stroke: "#fff",
      viewBox: "0 0 57 57",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd"
    }, n.a.createElement("circle", {
      cx: 5,
      cy: 50,
      r: 5
    }, n.a.createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      values: "50;5;50;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "cx",
      begin: "0s",
      dur: "2.2s",
      values: "5;27;49;5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 27,
      cy: 5,
      r: 5
    }, n.a.createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      from: 5,
      to: 5,
      values: "5;50;50;5",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "cx",
      begin: "0s",
      dur: "2.2s",
      from: 27,
      to: 27,
      values: "27;49;5;27",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 49,
      cy: 50,
      r: 5
    }, n.a.createElement("animate", {
      attributeName: "cy",
      begin: "0s",
      dur: "2.2s",
      values: "50;50;5;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "cx",
      from: 49,
      to: 49,
      begin: "0s",
      dur: "2.2s",
      values: "49;5;27;49",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))));
  };

  function p() {
    return (p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function d(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  m.propTypes = {
    className: c.a.string
  }, m.defaultProps = {
    className: void 0
  };

  var y = function y(e) {
    var t = e.className,
        a = d(e, ["className"]);
    return n.a.createElement("svg", p({
      width: 135,
      height: 140,
      fill: "#fff",
      viewBox: "0 0 135 140",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("rect", {
      y: 10,
      width: 15,
      height: 120,
      rx: 6
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 30,
      y: 10,
      width: 15,
      height: 120,
      rx: 6
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 60,
      width: 15,
      height: 140,
      rx: 6
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "y",
      begin: "0s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 90,
      y: 10,
      width: 15,
      height: 120,
      rx: 6
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("rect", {
      x: 120,
      y: 10,
      width: 15,
      height: 120,
      rx: 6
    }, n.a.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })));
  };

  function b() {
    return (b = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function v(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  y.propTypes = {
    className: c.a.string
  }, y.defaultProps = {
    className: void 0
  };

  var g = function g(e) {
    var t = e.className,
        a = v(e, ["className"]);
    return n.a.createElement("svg", b({
      width: 135,
      height: 135,
      fill: "#fff",
      viewBox: "0 0 135 135",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("path", {
      d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
    }, n.a.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 67 67",
      to: "-360 67 67",
      dur: "2.5s",
      repeatCount: "indefinite"
    })), n.a.createElement("path", {
      d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
    }, n.a.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 67 67",
      to: "360 67 67",
      dur: "8s",
      repeatCount: "indefinite"
    })));
  };

  function h() {
    return (h = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function O(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  g.propTypes = {
    className: c.a.string
  }, g.defaultProps = {
    className: void 0
  };

  var E = function E(e) {
    var t = e.className,
        a = O(e, ["className"]);
    return n.a.createElement("svg", h({
      width: 105,
      height: 105,
      fill: "#fff",
      viewBox: "0 0 105 105",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("circle", {
      cx: 12.5,
      cy: 12.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 12.5,
      cy: 52.5,
      r: 12.5,
      fillOpacity: .5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "100ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 52.5,
      cy: 12.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "300ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 52.5,
      cy: 52.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "600ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 92.5,
      cy: 12.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "800ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 92.5,
      cy: 52.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "400ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 12.5,
      cy: 92.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "700ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 52.5,
      cy: 92.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "500ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 92.5,
      cy: 92.5,
      r: 12.5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "200ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })));
  };

  function N() {
    return (N = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function x(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  E.propTypes = {
    className: c.a.string
  }, E.defaultProps = {
    className: void 0
  };

  var j = function j(e) {
    var t = e.className,
        a = x(e, ["className"]);
    return n.a.createElement("svg", N({
      width: 140,
      height: 64,
      fill: "#fff",
      viewBox: "0 0 140 64",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("path", {
      d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
      fillOpacity: .5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.4s",
      values: "0.5;1;0.5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("path", {
      d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
      fillOpacity: .5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0.7s",
      dur: "1.4s",
      values: "0.5;1;0.5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("path", {
      d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    }));
  };

  function w() {
    return (w = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function C(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  j.propTypes = {
    className: c.a.string
  }, j.defaultProps = {
    className: void 0
  };

  var M = function M(e) {
    var t = e.className,
        a = C(e, ["className"]);
    return n.a.createElement("svg", w({
      width: 38,
      height: 38,
      stroke: "#fff",
      viewBox: "0 0 38 38",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: 2,
      fill: "none",
      fillRule: "evenodd"
    }, n.a.createElement("circle", {
      strokeOpacity: .5,
      cx: 18,
      cy: 18,
      r: 18
    }), n.a.createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18"
    }, n.a.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    }))));
  };

  function P() {
    return (P = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function k(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  M.propTypes = {
    className: c.a.string
  }, M.defaultProps = {
    className: void 0
  };

  var S = function S(e) {
    var t = e.className,
        a = k(e, ["className"]);
    return n.a.createElement("svg", P({
      width: 44,
      height: 44,
      stroke: "#fff",
      viewBox: "0 0 44 44",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      strokeWidth: 2
    }, n.a.createElement("circle", {
      cx: 22,
      cy: 22,
      r: 1
    }, n.a.createElement("animate", {
      attributeName: "r",
      begin: "0s",
      dur: "1.8s",
      values: "1; 20",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.165, 0.84, 0.44, 1",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-opacity",
      begin: "0s",
      dur: "1.8s",
      values: "1; 0",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.3, 0.61, 0.355, 1",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 22,
      cy: 22,
      r: 1
    }, n.a.createElement("animate", {
      attributeName: "r",
      begin: "-0.9s",
      dur: "1.8s",
      values: "1; 20",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.165, 0.84, 0.44, 1",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-opacity",
      begin: "-0.9s",
      dur: "1.8s",
      values: "1; 0",
      calcMode: "spline",
      keyTimes: "0; 1",
      keySplines: "0.3, 0.61, 0.355, 1",
      repeatCount: "indefinite"
    }))));
  };

  function T() {
    return (T = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function _(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  S.propTypes = {
    className: c.a.string
  }, S.defaultProps = {
    className: void 0
  };

  var I = function I(e) {
    var t = e.className,
        a = _(e, ["className"]);

    return n.a.createElement("svg", T({
      width: 45,
      height: 45,
      stroke: "#fff",
      viewBox: "0 0 45 45",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(1 1)",
      strokeWidth: 2
    }, n.a.createElement("circle", {
      cx: 22,
      cy: 22,
      r: 6,
      strokeOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "r",
      begin: "1.5s",
      dur: "3s",
      values: "6;22",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-opacity",
      begin: "1.5s",
      dur: "3s",
      values: "1;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-width",
      begin: "1.5s",
      dur: "3s",
      values: "2;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 22,
      cy: 22,
      r: 6,
      strokeOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "r",
      begin: "3s",
      dur: "3s",
      values: "6;22",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-opacity",
      begin: "3s",
      dur: "3s",
      values: "1;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "stroke-width",
      begin: "3s",
      dur: "3s",
      values: "2;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 22,
      cy: 22,
      r: 8
    }, n.a.createElement("animate", {
      attributeName: "r",
      begin: "0s",
      dur: "1.5s",
      values: "6;1;2;3;4;5;6",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))));
  };

  function z() {
    return (z = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function B(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  I.propTypes = {
    className: c.a.string
  }, I.defaultProps = {
    className: void 0
  };

  var R = function R(e) {
    var t = e.className,
        a = B(e, ["className"]);
    return n.a.createElement("svg", z({
      width: 58,
      height: 58,
      viewBox: "0 0 58 58",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("g", {
      transform: "translate(2 1)",
      stroke: "#FFF",
      strokeWidth: 1.5,
      fill: "#fff",
      fillRule: "evenodd"
    }, n.a.createElement("circle", {
      cx: 42.601,
      cy: 11.462,
      r: 5
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "1;0;0;0;0;0;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 49.063,
      cy: 27.063,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;1;0;0;0;0;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 42.601,
      cy: 42.663,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;1;0;0;0;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 27,
      cy: 49.125,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;0;1;0;0;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 11.399,
      cy: 42.663,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;0;0;1;0;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 4.938,
      cy: 27.063,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;0;0;0;1;0;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 11.399,
      cy: 11.462,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;0;0;0;0;1;0",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 27,
      cy: 5,
      r: 5,
      fillOpacity: 0
    }, n.a.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1.3s",
      values: "0;0;0;0;0;0;0;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))));
  };

  function F() {
    return (F = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function W(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  R.propTypes = {
    className: c.a.string
  }, R.defaultProps = {
    className: void 0
  };

  var L = function L(e) {
    var t = e.className,
        a = W(e, ["className"]);
    return n.a.createElement("svg", F({
      width: 38,
      height: 38,
      viewBox: "0 0 38 38",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("defs", null, n.a.createElement("linearGradient", {
      x1: "8.042%",
      y1: "0%",
      x2: "65.682%",
      y2: "23.865%",
      id: "prefix__a"
    }, n.a.createElement("stop", {
      stopColor: "#fff",
      stopOpacity: 0,
      offset: "0%"
    }), n.a.createElement("stop", {
      stopColor: "#fff",
      stopOpacity: .631,
      offset: "63.146%"
    }), n.a.createElement("stop", {
      stopColor: "#fff",
      offset: "100%"
    }))), n.a.createElement("g", {
      transform: "translate(1 1)",
      fill: "none",
      fillRule: "evenodd"
    }, n.a.createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18",
      stroke: "url(#prefix__a)",
      strokeWidth: 2
    }, n.a.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      fill: "#fff",
      cx: 36,
      cy: 18,
      r: 1
    }, n.a.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    }))));
  };

  function D() {
    return (D = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = arguments[t];

        for (var r in a) {
          Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function q(e, t) {
    if (null == e) return {};

    var a,
        r,
        n = function (e, t) {
      if (null == e) return {};
      var a,
          r,
          n = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || (n[a] = e[a]);
      }

      return n;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        a = i[r], t.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
      }
    }

    return n;
  }

  L.propTypes = {
    className: c.a.string
  }, L.defaultProps = {
    className: void 0
  };

  var A = function A(e) {
    var t = e.className,
        a = q(e, ["className"]);
    return n.a.createElement("svg", D({
      width: 120,
      height: 30,
      fill: "#fff",
      viewBox: "0 0 120 30",
      className: "svg-loaders-svg".concat(t ? " ".concat(t) : "")
    }, a), n.a.createElement("circle", {
      cx: 15,
      cy: 15,
      r: 15
    }, n.a.createElement("animate", {
      attributeName: "r",
      from: 15,
      to: 15,
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "fill-opacity",
      from: 1,
      to: 1,
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 60,
      cy: 15,
      r: 9,
      fillOpacity: .3
    }, n.a.createElement("animate", {
      attributeName: "r",
      from: 9,
      to: 9,
      begin: "0s",
      dur: "0.8s",
      values: "9;15;9",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "fill-opacity",
      from: .5,
      to: .5,
      begin: "0s",
      dur: "0.8s",
      values: ".5;1;.5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), n.a.createElement("circle", {
      cx: 105,
      cy: 15,
      r: 15
    }, n.a.createElement("animate", {
      attributeName: "r",
      from: 15,
      to: 15,
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), n.a.createElement("animate", {
      attributeName: "fill-opacity",
      from: 1,
      to: 1,
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })));
  };

  A.propTypes = {
    className: c.a.string
  }, A.defaultProps = {
    className: void 0
  }, a.d(t, "Audio", function () {
    return s;
  }), a.d(t, "BallTriangle", function () {
    return m;
  }), a.d(t, "Bars", function () {
    return y;
  }), a.d(t, "Circles", function () {
    return g;
  }), a.d(t, "Grid", function () {
    return E;
  }), a.d(t, "Hearts", function () {
    return j;
  }), a.d(t, "Oval", function () {
    return M;
  }), a.d(t, "Puff", function () {
    return S;
  }), a.d(t, "Rings", function () {
    return I;
  }), a.d(t, "SpinningCircles", function () {
    return R;
  }), a.d(t, "TailSpin", function () {
    return L;
  }), a.d(t, "ThreeDots", function () {
    return A;
  });
}]);